export const environment = {
  production: true,
  // apiHost: "http://dev-apicuehome.iconflux.info/cue-home",
  apiHost: 'https://qa-api.cuehome.in/cue-home',
  platform_header: "WEB",
  otp_type:"EMAIL", //EMAIL | MOBILE
  register_type: "PWD", // PWD | OTP
  api_key:'c2b974a7-70b2-4996-8dd2-50341d230992',
  cueLocalUrl: 'http://dev.cuehome.local'
};
